import React, { useState } from 'react';
import './_report.scss';
import instance from '../../instance/AxiosInstance';
import { FaFlag } from 'react-icons/fa';

const ReportButton = ({ productId, productOwnerId }) => {
  const [reason, setReason] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleReport = async () => {
    try {
      await instance.post('api/user/product/report_product', {
        productId,
        productOwnerId,
        reason,
      });
      setSubmitted(true);
    } catch (err) {
      setError('Failed to report. Try again later.');
    }
  };

  const handleOpen = () => {
    setShowModal(true);
    setReason('');
    setSubmitted(false);
    setError(null);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <button className="report-trigger-btn" onClick={handleOpen}>
        <FaFlag style={{ marginRight: '6px' }} />
        Report
      </button>

      {showModal && (
        <div className="report-modal-backdrop">
          <div className="report-modal">
            <button className="close-btn" onClick={handleClose}>×</button>
            {!submitted ? (
              <>
                <h3>Report Product</h3>
                <textarea
                  placeholder="Enter reason for reporting..."
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />
                <button
                  onClick={handleReport}
                  className="submit-btn"
                  disabled={!reason}
                >
                  Submit Report
                </button>
                {error && <p className="error-message">{error}</p>}
              </>
            ) : (
              <p className="success-message">Report submitted. Thank you!</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ReportButton;
